import React from "react";
import { formatUtcDateToLocal, parseDate } from "../../../../../common/utils/TimeUtils";
import { AuthZTable, defaultPageSize, defaultPageSizeOptions } from "../../../../../components/authZTable";
import { ReviewedAccessController } from "./controller";
import "./index.scss";
import { generateReviewedAccessTableId } from "./model";
import { WithRoleLinkToolTip } from "../../../../../components/RoleLinkToolTip";
import { TextWithSubTitle } from "../../../../../components/textWithSubTitle";

export const ReviewedAccesses = (props) => {
  const { userId, appId } = props;
  const filterTitle = ["Review Decision taken"];
  const fixWidthTitles = ["Review Decision taken", "Comments", "Reviewed by", "Reviewed at"];

  const { data, columns, isLoading, accessTypeLink } = ReviewedAccessController(userId, appId);

  let modifiedColumns = columns.map((column, columnIndex) => {
    let { title, render, tableFilter, ...restKeys } = column;
    let titleStyles = {};
    if (columnIndex === 0) {
      restKeys = {
        ...restKeys,
        fixed: "left",
      };
      titleStyles = { fontWeight: 600, ...titleStyles };
    }
    if (render === "TextWithSubTitleComponent") {
        render = (titles, record) => (
          <>
            {accessTypeLink ? (
              <WithRoleLinkToolTip
                accessTypeLink={accessTypeLink}
                column={column}
                dataTestId={`role-link-${record.key}`}
              >
                <TextWithSubTitle titles={titles} titleStyles={titleStyles} />
              </WithRoleLinkToolTip>
            ) : (
              <TextWithSubTitle titles={titles} titleStyles={titleStyles} />
            )}
          </>
        );
    }
    if (!render) {
      render = (text, record) => {
        return text
          ? (
            <WithRoleLinkToolTip accessTypeLink={accessTypeLink} column={column} dataTestId={`role-link-${record.key}`}>
              {text}
            </WithRoleLinkToolTip>
          )
          : null;
      };
    }
    restKeys = {
      ...restKeys,
      searchEnabled: false,
      sortEnabled: false,
      filterEnabled: false,
      width: 140,
    };
    if (column.key === "reviewedAt") {
      render = (dateStr) => {
        if (dateStr === "") return dateStr;
        return formatUtcDateToLocal(parseDate(dateStr), "YYYY-MM-DD HH:mm:ss");
      };
      restKeys = {
        ...restKeys,
        render,
      };
    }

    if (filterTitle.includes(title)) {
      restKeys = {
        ...restKeys,
        filters: tableFilter,
        filterEnabled: true,
      };
    }
    if (fixWidthTitles.includes(title)) {
      restKeys = {
        ...restKeys,
        width: 150,
      };
    } else if ("Review name" === title) {
      restKeys = {
        ...restKeys,
        width: 170,
      };
    }
    return { ...restKeys, title: title, render: render };
  });

  return (
    <div>
      <AuthZTable
        className={"reviewedAccessTable"}
        id={generateReviewedAccessTableId(userId, appId)}
        columns={modifiedColumns}
        dataSource={data}
        loading={isLoading}
        scroll={{ x: "max-content", y: "calc(64vh)" }}
        rowClassName={(record) => {
          let className = "";
          if (record.newReview) className = "top-divider";
          return className;
        }}
        pagination={{
          showSizeChanger: true,
          pageSizeOptions: defaultPageSizeOptions,
          showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
          defaultPageSize: defaultPageSize,
          defaultCurrent: 1,
          showQuickJumper: true,
        }}
      />
    </div>
  );
};
